import { splitSignature } from '@ethersproject/bytes';
import axios from 'axios';
import Web3 from 'web3';
import type { provider } from 'web3-core';
import type { AbiItem } from 'web3-utils';

import { configs } from '@/configs';
import createNetworkOrSwitch from '@/utils/createNetworkOrSwitch';

const RPC_URL_56_MAINNET = 'https://bsc-dataseed1.ninicoin.io/';
const RPC_URL_97_TESTNET = 'https://data-seed-prebsc-1-s1.binance.org:8545';
const RPC_URL_1 = 'https://mainnet.infura.io/v3/920d962b397d4646989aa594147ba78c';

export type CHAIN_ID_TYPE = 1 | 56 | 97;

export const RPC_URLS = {
  1: RPC_URL_1,
  56: RPC_URL_56_MAINNET,
  97: RPC_URL_97_TESTNET,
};

export const CHAIN_ID = Number(configs.chainIdBsc) as CHAIN_ID_TYPE;
export const CHAIN_ID_HEX = '0x38';

export const write = async (
  method: any,
  provider: provider,
  address: string,
  abi: AbiItem | AbiItem[],
  account: string,
  params: any,
  callback: (hash: string) => void,
  value: number = 0,
) => {
  const web3 = new Web3(provider);
  const contract = new web3.eth.Contract(abi, address);
  let response;
  let sendObj;
  if (value > 0) sendObj = { from: account, value };
  else sendObj = { from: account };
  await contract.methods[method](...params)
    .send(sendObj)
    .on('transactionHash', (hash: string) => {
      console.log('txhash', hash);
      if (callback) {
        callback(hash);
      }
    })
    .on('receipt', (receipt: any) => {
      console.log(receipt);
      response = receipt;
    });
  return response;
};

export const sign = async (account: string, data: any, provider: any) => {
  let res = await provider.send('eth_signTypedData_v4', [account, data]);
  if (res.result) {
    res = res.result;
  }
  return splitSignature(res);
};

export const read = async (
  method: any,
  address: string,
  abi: AbiItem | AbiItem[],
  params: any,
  from: string | null = null,
  chainId: number = CHAIN_ID,
) => {
  try {
    const web3 = new Web3(RPC_URLS[chainId as CHAIN_ID_TYPE]);
    const contract = new web3.eth.Contract(abi, address);
    if (from)
      return await contract.methods[method](...params)?.call({
        from,
      });
    return await contract.methods[method](...params)?.call();
  } catch (error) {
    console.log('error is: ', error, method, params);
  }
};

export const getEthBalance = (address: string) => {
  const web3 = new Web3(RPC_URLS[CHAIN_ID]);
  try {
    return web3.eth.getBalance(address);
  } catch {
    return Promise.resolve(0);
  }
};

export const estimateGasPrice = () => {
  const data = JSON.stringify({
    jsonrpc: '2.0',
    method: 'eth_gasPrice',
    params: [],
    id: 1,
  });
  const config = {
    method: 'post',
    url: 'https://mainnet.infura.io/v3/98a353b7d2c74317b66a017bc20563a2',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  };
  return axios(config);
};

export const checkChainId = async (chainId: number | undefined) => {
  if (chainId !== CHAIN_ID) {
    const error = await createNetworkOrSwitch();
    if (error) {
      throw new Error('Please change network to Binance smart chain');
    }
  }
};
